import MeterRouter from "@/context/meter/router/MeterRouter";
import Routes from "@/common/router/Routes";

export default class MeterRoutes extends Routes {
  constructor() {
    super({
      label: "Licznik",
      router: new MeterRouter(),
      lazyPage: () => import("@/context/meter/page/MeterPage.vue"),
      lazyCreate: () => import("@/context/meter/containers/MeterCreateContainer.vue"),
      lazyUpdate: () => import("@/context/meter/containers/MeterUpdateContainer.vue"),
      lazyList: () => import("@/context/meter/containers/MeterListContainer.vue"),
      lazyShow: () => import("@/context/meter/containers/MeterShowContainer.vue")
    });
  }
}
